import React  from 'react';

const TrashIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13.714" viewBox="0 0 12 13.714">
  <path id="trash-solid" d="M3.621.474,3.429.857H.857a.857.857,0,0,0,0,1.714H11.143a.857.857,0,1,0,0-1.714H8.571L8.379.474A.854.854,0,0,0,7.613,0H4.388A.854.854,0,0,0,3.621.474Zm7.521,2.954H.857l.568,9.08a1.287,1.287,0,0,0,1.283,1.205H9.292a1.287,1.287,0,0,0,1.283-1.205Z" fill="#515c77"/>
</svg>


}

export default TrashIcon;
